import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'convertCircleColor'
})
export class ConvertCircleColorPipe implements PipeTransform {
  transform(value: any, args ? : any): any {
    const days = Math.floor(moment(new Date()).diff(moment(value, 'DD/MM/YYYY'), 'days', true));
    let template: string;

    if (days <= 270) {
      template = '<span class="dot green"></span>';
    } else if (days > 270 && days <= 330) {
      template = '<span class="dot yellow"></span>';
    } else if (days > 330 && days <= 365) {
      template = '<span class="dot red"></span>';
    } else {
      template = '<span class="dot black"></span>';
    }

    return template;
  }

}
